import { ResourceLanguage } from 'i18next';

const translations: ResourceLanguage = {
  app: {
    titleBLS: 'Registrierung - Bikeleasing',
    titleProbonio: 'Registrierung - Probonio',
  },
  common: {
    or: 'oder',
    actions: {
      back: 'Zurück',
      next: 'Weiter',
      backToHomepage: 'Zurück zur Startseite',
      close: 'Schließen',
    },
    errors: {
      networkError: 'Ein Netzwerkfehler ist aufgetreten',
      rateLimitExceeded: 'Zu viele Anfragen. Bitte versuche es später erneut.',
      unknownError: 'Ein unbekannter Fehler ist aufgetreten',
    },
    lang: {
      en: 'Englisch',
      de: 'Deutsch',
    },
  },
  accessibility: {
    login: 'Anmelden',
    signInGoogle: 'Mit Google anmelden',
    signInMicrosoft: 'Mit Microsoft anmelden',
    signInApple: 'Mit Apple anmelden',
    closeDialog: 'Dialog schließen',
    copyEmail: 'Support-E-Mail kopieren',
  },
  auth: {
    title: 'Authentifizierung läuft',
    message: 'Wir melden Sie gerade an und bereiten alles vor. Dies kann einen Moment dauern. Bitte laden Sie die Seite nicht neu.',
  },
  footer: {
    privacy: 'Datenschutzerklärung',
    support: 'Support',
    imprint: {
      title: 'Impressum',
      companyName: {
        title: 'Name der Gesellschaft:',
        content: 'BLS Benefit Leasing Service Plattform GmbH',
      },
      representedBy: {
        title: 'Vertreten durch:',
        content: 'Den Geschäftsführer Othmane Khelil',
      },
      address: {
        title: 'Anschrift:',
        content: 'Geschäftsanschrift: Bewdley-Platz 18<br/>34246 Vellmar',
      },
      contact: {
        title: 'Kontakt:',
        content: 'Telefon: <0>{{phone}}</0><br/>E-Mail: <1>{{email}}</1>',
      },
      registerEntry: {
        title: 'Registereintrag:',
        content: 'Eintragung im Handelsregister.<br/>Registergericht: Amtsgericht Kassel<br/>Handelsregisternummer: HRB 20519',
      },
      vatId: 'Umsatzsteuer-ID gemäß § 27a UStG:',
      editorial: {
        title: 'Redaktionell verantwortlich gemäß § 18 Abs. 2 MStV:',
        content: 'Othmane Khelil, Bewdley-Platz 18, 34246 Vellmar',
      },
    },
  },
  notFound: {
    title: 'Seite nicht gefunden',
    message:
      'Die angeforderte Seite existiert nicht oder wurde verschoben. Bitte überprüfen Sie die URL oder kehren Sie zur Startseite zurück.',
  },
  registration: {
    title: 'Registrierung',
    message:
      'Den Firmencode erhalten Sie von Ihrem Arbeitgeber. Sollte dies nicht der Fall sein, überprüfen Sie bitte Ihre E-Mails oder wenden Sie sich direkt an Ihren Arbeitgeber.',
    employerCodeLabel: 'Firmencode',
    employerCodeHelpProbonio: 'Code mit 4, 8 oder 12 Zeichen',
    employerCodeHelpBLS: 'Code mit 4 Zeichen',
    employer: 'Arbeitgeber: {{companyName}}',
    choosePreferredMethod: 'Bitte wählen Sie Ihre bevorzugte Registrierungsmethode, mit der Sie sich auch in Zukunft anmelden werden.',
    consent: {
      privacyPolicy: 'In unserer <0>Datenschutzerklärung</0> erfährst du, wie wir deine Daten verarbeiten.',
      marketingConsent:
        'Ich stimme zu, dass die Unternehmen der BLS Beteiligungs GmbH mich persönlich über interessante Angebote und Neuigkeiten in den Bereichen Dienstrad-Leasing, Versicherung, Mitarbeitervorteile und gebrauchte Fahrräder informieren und beraten darf. Meine Zustimmung ist freiwillig und kann jederzeit widerrufen werden. <0>Weitere Details</0>',
    },
    alreadyAnAccount: 'Bereits ein Konto?',
    alreadySignedIn: 'Sie sind bereits angemeldet:',
    dividerLabel: 'oder fortfahren mit',
    completeData: 'Daten vervollständigen',
    firstName: 'Vorname',
    lastName: 'Nachname',
    phoneNumber: 'Telefonnummer',
    phoneNumberInvalid: 'Ungültige Telefonnummer. Beispiel einer gültigen Telefonnummer: {{EXAMPLE_VALID_PHONE_NUMBER}}',
    address: {
      street: 'Straße und Hausnummer',
      postalCode: 'Postleitzahl',
      city: 'Stadt',
      country: 'Land',
    },
    employeeRecord: {
      employeeNumber: 'Personalnummer',
      costCenter: 'Kostenstelle',
      bikeleasing: {
        employeeNumber: 'Personalnummer / ValueNet-ID',
        employeeNumberHint:
          'Ist das Unternehmen über ValueNet beim Bikeleasing-Service eingebunden, ist die ValueNet-ID anstatt Personalnummer zwingend erforderlich.',
        costCenterPlaceholder: '0 falls nicht bekannt',
      },
    },
    actions: {
      register: 'Mit E-Mail registrieren',
      login: 'Hier klicken!',
      finish: 'Registrierung abschließen',
      switchAccount: 'Mit einem anderen Konto anmelden?',
    },
    errors: {
      invalidCode: 'Der eingegebene Code ist ungültig oder wurde bereits verwendet',
      expiredCode: 'Der eingegebene Code ist abgelaufen',
    },
  },
  errorDialog: {
    title: 'Hoppla! Etwas ist schiefgelaufen',
    alertMessage:
      'Wenn das Problem weiterhin besteht, haben Sie möglicherweise die maximale Anzahl an Anfragen erreicht. Versuchen Sie es in einigen Minuten erneut oder wenden Sie sich an den Support, um Hilfe zu erhalten.',
    actions: {
      contactSupport: 'Support kontaktieren',
      restartRegistration: 'Registrierung erneut starten',
      loginAgain: 'Erneut anmelden',
    },
    messages: {
      redeemError:
        'Wir konnten Ihren Registrierungscode nicht mit Ihrem Konto verknüpfen. Dies kann passieren, wenn der Code bereits verwendet wurde oder aufgrund eines vorübergehenden Systemproblems. Bitte starten Sie den Registrierungsvorgang erneut. Vergewissern Sie sich, dass Ihr Registrierungscode korrekt ist und Ihre Internetverbindung stabil ist.',
      employeeEmailAlreadyExists:
        'Die E-Mail-Adresse, die mit diesem Registrierungscode verknüpft ist, existiert bereits in unserem System. Dies kann passieren, wenn Sie sich bereits registriert haben oder wenn es ein Problem mit dem Registrierungscode gibt. Bitte versuchen Sie, sich mit Ihrer E-Mail-Adresse anzumelden oder wenden Sie sich an den Support, um Hilfe zu erhalten.',
      registrationCodeEmployeeMismatch:
        'Sie sind mit diesem Konto bereits als anderer Mitarbeiter in dieser Firma registriert. Dieser Registrierungscode gehört zu einem anderen Mitarbeiterprofil. Bitte melden Sie sich mit dem passenden Konto an oder wenden Sie sich an Ihren Arbeitgeber, wenn Sie Hilfe benötigen.',
      employeeError:
        'Wir konnten Ihre Kontodaten nicht laden. Dies geschieht in der Regel, wenn Ihre Sitzung abgelaufen ist oder aufgrund eines vorübergehenden Systemproblems. Bitte versuchen Sie erneut, sich anzumelden. Stellen Sie sicher, dass Ihre Internetverbindung stabil ist.',
    },
  },
  mailNotVerified: {
    alert: 'Deine E-Mail-Adresse wurde noch nicht bestätigt',
    message:
      'Um fortzufahren, bestätigen Sie bitte Ihre E-Mail-Adresse <strong>{{email}}</strong>. Sobald Sie die Bestätigung abgeschlossen haben, klicken Sie auf den Knopf unten, um fortzufahren.',
    checkAgain: 'Erneut prüfen',
  },
  redeemCode: {
    title: 'Ihr Code wird eingelöst',
    message:
      'Wir verarbeiten Ihren Registrierungscode und bereiten Ihr Konto vor. Dies kann einen Moment dauern. Bitte laden Sie die Seite nicht neu.',
  },
  registrationComplete: {
    title: 'Danke für deine Registrierung',
    login: 'Login',
    autoApproveMessage:
      'Dein Account wurde erfolgreich erstellt und ist jetzt aktiv. Du kannst dich nun mit der von dir gewählten Methode in {{app}} anmelden.',
    manualApproveMessage:
      'Sobald dein Arbeitgeber deinen Account freigegeben hat, erhältst du eine E-Mail und kannst dich mit der von dir gewählten Methode in {{app}} anmelden.',
  },
  checkRegistrationLink: {
    title: 'Registrierung',
    message: 'Wir überprüfen Ihren Registrierungslink. Dies kann einen Moment dauern. Bitte laden Sie die Seite nicht neu.',
    actions: {
      login: 'Bei {{app}} anmelden',
      useCodeInstead: 'Stattdessen mit Code registrieren',
    },
    errors: {
      title: 'Ungültiger Registrierungslink',
      invalidLink:
        'Der Registrierungslink ist ungültig oder wurde bereits verwendet. Dies kann passieren, wenn Sie den Link mehrfach aufgerufen haben oder wenn der Link fehlerhaft übertragen wurde.',
      expiredLink:
        'Der Registrierungslink ist abgelaufen. Registrierungslinks sind nur für einen begrenzten Zeitraum gültig, um die Sicherheit Ihres Kontos zu gewährleisten.',
      alertText:
        'Bitte kontaktieren Sie Ihren Arbeitgeber, um einen neuen Link zu erhalten. Falls Sie bereits ein Konto haben, melden Sie sich bitte hier an.',
    },
  },
  completeProfileAfterRegistration: {
    title: 'Suche nach unvollständigem Profil',
    message:
      'Wir prüfen, ob ein unvollständiges Profil mit Ihrem Konto existiert. Dies kann einen Moment dauern. Bitte laden Sie die Seite nicht neu.',
    noEmployeeFound: {
      title: 'Kein unvollständiges Profil gefunden',
      message:
        'Gute Nachrichten! Wir konnten keine unvollständigen Profile zu Ihrem Konto finden. Das bedeutet, dass Ihre Registrierung abgeschlossen ist und Sie sich anmelden und die App nutzen können.',
    },
  },
  completeData: {
    errors: {
      conflict: 'Die angegebene Personalnummer existiert bereits',
      missingRequiredField: 'Ein erforderliches Feld wurde nicht ausgefüllt',
      notEligible: {
        DuplicateEmployeeNumber: 'Die angegebene Personalnummer existiert bereits',
        RegisterValidationFailed: 'Ungültige Eingaben, bitte überprüfen Sie Ihre Daten',
        GoogleValidationFailed: 'Ihre Daten wurden nicht gefunden, bitte prüfen Sie die Eingabe',
        EligibilityCheckFailed:
          'Ihre Daten konnten nicht verifiziert werden, bitte überprüfen Sie Ihre Eingaben oder kontaktieren Sie Ihren Arbeitgeber.',
      },
    },
  },
  employerSpecialConfig: {
    app: {
      registration: {
        cost_center: {
          brk: 'Mandantennummer',
          location_store: 'Standort Markt',
        },
      },
      registration_cost_center_error: {
        porr_8_signs: 'Die Kostenstelle muss 8-stellig sein.',
      },
      registration_personal_number_error: {
        enbw_len: 'Bitte geben Sie ihre 7-stellige Personalnummer ein.',
        enbw_more_than_4:
          'Ihre Eingabe entspricht nicht den formalen Kriterien. Um eine unverzügliche und korrekte Bearbeitung ihres Antrags gewährleisten zu können, ist Ihre korrekte Personalnummer zwingend erforderlich (s. Entgeltnachweis).',
        lufthansa_not_allowed: 'Diese Nummer entspricht nicht den formalen Anforderungen. Bitte überprüfen.',
        lufthansa_u123456: 'Die Personalnummer sollte dem Muster U012345 entsprechen',
        porr_between_6_and_9: 'Bitte beachten Sie, dass Ihre Personalnummer zwischen 6 und 9 Stellen lang sein muss.',
        title: 'Bitte füllen Sie dieses Feld aus. Falls Sie diesen Wert nicht kennen, tragen Sie einfach eine 0 ein.',
      },
      registration_personal_number_label: {
        lufthansa: 'Bitte beachten Sie, dass die Personalnummer 7-stellig sein muss (U012345).',
      },
    },
    // These translations are used in the employer-specific configuration of the registration form. The keys correspond to the possible values of `registerValidation.fieldLabel` from the API response.
    Kostenstelle: 'Kostenstelle',
    Personalnummer: 'Personalnummer',
  },
};

export default translations;
